import { css } from '@emotion/react';

import useTheme from '../../hooks/useTheme';

export default () => {
  const { colors } = useTheme();

  return {
    skipToMainLinkVisible: css`
      z-index: 999;
      border-radius: 0.25rem;
      padding: 0.75rem 3.75rem;
      font-family: FS Dillon;
      font-size: 1rem;
      letter-spacing: 0.125rem;
      text-decoration: none;
      background-color: ${colors.skip_yellow};
      border: 2px solid ${colors.border_black};
      color: ${colors.border_black};
      cursor: pointer;
      top: 0.88rem;
      left: 0.88rem;
      position: fixed;
      opacity: 1;
      &:focus {
        outline: 2px solid ${colors.skip_yellow};
      }
    `,
    skipToMainLinkHidden: css`
      position: absolute;
      left: -1000rem;
      opacity: 0;
    `,
  };
};
